import * as React from 'react';
import QrScanner from 'react-qr-barcode-scanner';

const BarcodeScanner = () => {
  // const [data, setData] = useState('No result'); // Holds the scanned result
  // const [isCameraActive, setIsCameraActive] = useState(false); // Toggle camera


  // const handleScan = (result) => {
  //   if (result) {
  //     setData(result.text); // Extract scanned data
  //     setIsCameraActive(false); // Stop scanning after successful read
  //   }
  // };

  // const handleError = (error) => {
  //   console.error('Camera error:', error);
  // };

  let code = React.useRef(undefined);
  let bc = React.useRef(undefined);
  let init = React.useRef(false);

  // Connection to a broadcast channel

  // A handler that only logs the event to the console:

  

  React.useEffect(() => {
    if(init.current){
      return;
    }

    init.current = true;
    bc.current = new BroadcastChannel("test_channel_001");
    bc.current.onmessage = handleMsg;

    handleCodeExtrac();
  });

  const handleMsg = async(e) => {
    console.log(e);
  };

  const handleCodeExtrac = async() => {

    let params = new URLSearchParams(document.location.search);
    let info = params.get("code"); 
    console.log(info);
  }


  const handleLogin = async() => {
    // const url = 'https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fspreadsheets%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.file&response_type=code&client_id=467300364263-spf19g44dckvdp9havog92uk1atc8f16.apps.googleusercontent.com&redirect_uri=http%3A%2F%2Flocalhost%3A8080'
    const url = 'http://192.168.100.211:3000/tst??iss=https%3A%2F%2Faccounts.google.com&code=4%2F0Aci98E_ype5Eilc1ePYeItKUSpvIrSNUB5ImqsqGk4bWKiC02Bmks224tsaWPFcfLre6qA&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.file+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fspreadsheets'
    window.open(url, "", "width=200,height=100");
  }

  const submitUpdate = async () => {
    const payload = {
      nombre : 'carlos',
      msg: 123
    };

    bc.current.postMessage(payload);
  };

  return (
    <div>
      {/* <h1>Barcode Scanner</h1>
      <h2>{data}</h2>
      {isCameraActive ? (
        <QrScanner
          delay={300} // Milliseconds between scans
          onError={handleError}
          onScan={handleScan}
          onUpdate={(err, result) => {
            if (result) {
                setData(result.text);
                setIsCameraActive(false)
            }
            else setData("Not Found");
          }}
          style={{ width: '50%' }}
        />
      ) : (
        <p>Scanning stopped. Scanned Data: {data}</p>
      )}
      <button onClick={() => setIsCameraActive(true)}>Restart Scanner</button> */}
      <h1>Testing page</h1>
      <button onClick={() => handleCodeExtrac()}>Logg</button> 
      <button onClick={() => handleLogin()}>open</button> 
      <button onClick={() => submitUpdate()}>send</button> 
    </div>
  );
};

export default BarcodeScanner;
